import { constructFrom } from "./constructFrom.js";

/**
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 */
export function toDate(argument, context) {
  /*                                             */
  return constructFrom(context || argument, argument);
}

/*                                */
export default toDate;
